import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import AppLayout from '@/components/AppLayout.vue';
import AppHeader from '@/components/header';
import AppFooter from '@/components/footer';
import ViewTemplate from './views/ViewTemplate.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AppLayout, null, {
    header: _withCtx(() => [
      _createVNode(_unref(AppHeader))
    ]),
    main: _withCtx(() => [
      _createVNode(ViewTemplate)
    ]),
    footer: _withCtx(() => [
      _createVNode(_unref(AppFooter))
    ]),
    _: 1 /* STABLE */
  }))
}
}

})